import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConversationSourceLookupComponent } from './conversation-source-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ConversationSourceLookupComponent],
  exports: [ConversationSourceLookupComponent]

})
export class ConversationSourceLookupModule { }
